export default __webpack_public_path__ + "static/media/atb.72f917a8.png";